import Style from './StepBrick.module.less';
import useLocalStore from '../../../src/hooks/useLocalStore';
import FJAction from '../../action/FJAction';
import { useSelector, useDispatch } from 'react-redux';
import SetPasswordContainer from '../SetYourPassword/SetPasswordContainer';
import LoginMinRegisterContainer from '../LoginMixRegisterBrick/LoginMinRegisterContainer';
import LoginContainer from '../LoginBrick/LoginContainer';
import ConfirmEmailContainer from '../ConfirmationEmailBrick/ConfirmEmailContainer';
import VerificationCodeContainer from '../VerificationCodeBrick/VerificationCodeContainer';
import ResetPasswordContainer from '../ResetPasswordBrick/ResetPasswordContainer';
import NewUserVerifyEmailCode from '../NewUserVerifyEmailCode/NewUserVerifyEmailCode';

const StepBrick = props => {
    let { popupType = false, hasLogo, style } = props;
    useLocalStore();
    const dispatch = useDispatch();
    // default|register注册|login登录|confirmationEmail确认邮箱|verificationCode输入验证码|resetPassword重置密码
    const { step } = useSelector(store => {
        return {
            step: store.mainStore.step,
        };
    });

    // 步骤切换
    let stepChange = stepName => {
        dispatch(FJAction.changeStep(stepName));
    };

    return (
        <div className={Style.step_single_login} style={style}>
            {step === 'default' && (
                <LoginMinRegisterContainer hasLogo={hasLogo} stepChange={stepChange} popupType={popupType} />
            )}
            {/*新用户输入email之后进行email邮箱发送的验证码验证*/}
            {step === 'verifyEmailCode' && (
                <NewUserVerifyEmailCode
                    stepChange={stepChange}
                    popupType={popupType}
                    active={step === 'verifyEmailCode'}
                />
            )}
            {step === 'setPassword' && (
                <SetPasswordContainer stepChange={stepChange} popupType={popupType} active={step === 'setPassword'} />
            )}
            {step === 'login' && <LoginContainer stepChange={stepChange} popupType={popupType} />}
            {step === 'confirmationEmail' && <ConfirmEmailContainer stepChange={stepChange} popupType={popupType} />}
            {step === 'verificationCode' && (
                <VerificationCodeContainer
                    stepChange={stepChange}
                    popupType={popupType}
                    active={step === 'verificationCode'}
                />
            )}
            {step === 'resetPassword' && <ResetPasswordContainer stepChange={stepChange} popupType={popupType} />}
        </div>
    );
};
export default StepBrick;
